import * as React from "react";
import { Typography } from "antd";
import Report6PreviewReportsGrid from "./Report6PreviewReportsGrid";
import { TReport6ReportingPeriodPresentationModel } from "../../../presenter/report/model/Report6ReportingPeriodPresentationModel";

const Report6PreviewReportingPeriod = ({
  translate,
  reportingPeriod
}: {
  translate: any;
  reportingPeriod: TReport6ReportingPeriodPresentationModel;
}) => {
  return (
    <div>
      <Typography.Title style={{ fontSize: 15, marginBottom: 10 }}>
        {`${translate("report6_preview_reporting_period.name")}: ${
          reportingPeriod.name
        }`}
      </Typography.Title>
      <Typography.Paragraph>{`${translate(
        "report6_preview_reporting_period.additional_evaluation"
      )}: ${
        reportingPeriod.additionalEvaluation
          ? translate("basic.yes")
          : translate("basic.no")
      }`}</Typography.Paragraph>
      <Typography.Paragraph>{`${translate(
        "report6_preview_reporting_period.additional_evaluation_date"
      )}: ${reportingPeriod.additionalEvaluationDate}`}</Typography.Paragraph>
      <Typography.Paragraph>{`${translate(
        "report6_preview_reporting_period.additional_evaluation_reason"
      )}: ${
        reportingPeriod.additionalEvaluationReason || ""
      }`}</Typography.Paragraph>
      <Report6PreviewReportsGrid
        translate={translate}
        reportingPeriod={reportingPeriod}
      ></Report6PreviewReportsGrid>
    </div>
  );
};

export default Report6PreviewReportingPeriod;
